import React from "react";

const PopupTerminosCondicionesPeru = ({ filePath, onClose }) => {

  const styles = {
    modal: {
      display: "block",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    modalDialog: {
      maxWidth: "700px",
    },
    closeButton: {
      position: "absolute",
      top: "10px",
      right: "10px",
      background: "transparent",
      border: "none",
      fontSize: "24px",
      cursor: "pointer",
    },
    modalContent: {
      padding: "20px",
    },
    scrollableContent: {
      height: "600px",
      overflowY: "auto",
    },
    heading1: {
      textAlign: "center",
      fontSize: "1.5rem",
      marginBottom: "20px",
    },
    heading2: {
      marginTop: "20px",
      fontSize: "1.25rem",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      margin: "20px 0",
    },
    th: {
      border: "1px solid #ddd",
      padding: "10px",
      backgroundColor: "#f4f4f4",
      textAlign: "left",
    },
    td: {
      border: "1px solid #ddd",
      padding: "10px",
      textAlign: "left",
    },
    ul: {
      marginTop: "10px",
      paddingLeft: "20px",
    },
    li: {
      marginBottom: "10px",
    },
    signatureSection: {
      marginTop: "40px",
    },
    signatureLine: {
      marginTop: "20px",
      borderTop: "1px solid #000",
      width: "50%",
    },
  };

  return (
    <div>
      <div
        className="modal fade show"
        style={styles.modal}
        tabIndex="-1"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          style={styles.modalDialog}
        >
          <div className="modal-content modal-succes">
            <div className="modal-body body-cita-confirmada" style={styles.modalContent}>
              <button onClick={onClose} style={styles.closeButton}>
                &times;
              </button>
              {/* Mostramos el contenido */}
              <div style={styles.scrollableContent}>
                <p>
                    Uso de información para fines adicionales
                </p>

                <h1 style={styles.heading1}>
                    <strong>AUTORIZACIÓN PARA EL TRATAMIENTO DE DATOS PERSONALES</strong>
                </h1>

                <p>
                    Por medio de la presente, y en cumplimiento de la Ley N° 29733, Ley de Protección de Datos Personales y su Reglamento, autorizo a <strong>Ópticas GMO Perú S.A.C.</strong>, domiciliada Calle Amador Merino Reyna 223 Of. 1201, San Isidro, provincia y departamento de Lima, para que recopile mis datos personales, con la finalidad de desarrollar acciones de marketing, publicitarias, promocionales, preparación de estadísticas, elaboración de perfiles, realización de contactos (llamadas, mensajes de texto, mensajes de correo electrónico) (ii) participar en estudios de investigación de mercado; (iii) publicidad y prospección comercial; y (iv) comunicarle sobre promociones, beneficios, concursos y ofertas.
                </p>

                <p>
                    Estos datos personales serán almacenados en el banco de datos personales de titularidad de <strong>Ópticas GMO Perú S.A.C.</strong> declarados ante la Autoridad Nacional de Protección de Datos Personales denominado Usuarios de la página web (Reg. 17732). Estos datos personales se conservarán mientras sean necesarios para la finalidad autorizada o hasta que no se solicite su cancelación por el titular.
                </p>
                
                <p>
                    Para cumplir con las finalidades señaladas previamente, <strong>Ópticas GMO Perú S.A.C.</strong> podrá tratar sus datos personales directamente o transferirlos a destinatarios autorizados, y son los que en la actualidad se encuentran listados a continuación:
                </p>

                <ul>
                    <li>
                        Estados Unidos de América: Amazon Web Services ID:00004, con fines de almacenamiento de datos.
                    </li>
                    <li>
                        Chile Opticas Grandvision Chile Limitada RUT:76025494-0, con fines de automatización de campañas y estrategia de Marketing Digital.
                    </li>
                </ul>

                <p>
                    En cualquier caso, <strong>Ópticas GMO Perú S.A.C.</strong> garantiza la confidencialidad y seguridad de los datos personales que recopila y transfiere.
                </p>

                <p>
                    Asimismo, mediante la presente, usted manifiesta estar debidamente informado de que, como titular de sus datos personales, puede ejercer sus derechos de Acceso, Rectificación, Cancelación y Oposición, así como revocar su consentimiento, a través del correo electrónico <a href="mailto:Ejecutivo.ServicioCliente07@pe.luxottica.com">Ejecutivo.ServicioCliente07@pe.luxottica.com</a> o en nuestras oficinas ubicadas en la dirección previamente señalada.
                </p>

                <p>
                    Finalmente, para más información sobre el tratamiento de sus datos personales, solicitamos consultar la Política de Privacidad del Sitio Web disponible en: <a href="https://www.visioncenter.com.pe/pages/politica-de-privacidad" target="_blank" rel="noopener noreferrer">https://www.visioncenter.com.pe/pages/politica-de-privacidad</a>
                </p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupTerminosCondicionesPeru;
